import React from "react";
import {
  Article,
  ArticleContainer,
  BackButton,
  MainContainer,
  Title,
  Author,
} from "./DetailedArticle.styles";
import { NavLink, useNavigate } from "react-router-dom";

const DetailedArticle = ({ title, author, description, handleBack }) => {
  const nav = useNavigate();

  return (
    <MainContainer>
      <NavLink to={"/"} style={{ textDecoration: "none" }}>
        <BackButton onClick={() => nav(-1)}>{"< Atrás"}</BackButton>
      </NavLink>
      <ArticleContainer>
        <Title>{title}</Title>
        {author && <Author>{`Por: ${author}`}</Author>}
        <Article>{description}</Article>
      </ArticleContainer>
    </MainContainer>
  );
};

export default DetailedArticle;
